import { useParams } from "react-router";
import { useFirebase } from "../FbContex";
import { activeNodes, allRooms, findRoom } from "../lib/selectors";
import DeviceWidget from "../components/widgets/DeviceWidget";
import NotFound from "./404";

export default function Room() {
  const { slug } = useParams<{ slug: string }>();
  const { rooms, devices } = useFirebase();

  // Old links used the room's array index. Resolve those too for one release.
  const legacy =
    /^\d+$/.test(slug ?? "") ? allRooms(rooms)[Number(slug)] : undefined;
  const room = findRoom(rooms, slug) ?? legacy;

  if (!room) return <NotFound />;

  const nodes = activeNodes(devices, room.id);

  return (
    <div className="p-4">
      <h2 className="font-bold text-lg mb-4 opacity-70">{room.name}</h2>
      {nodes.length === 0 && (
        <div className="opacity-50 text-sm">No devices in this room yet.</div>
      )}
      {nodes.map((node) => (
        <DeviceWidget key={node.id} node={node} />
      ))}
    </div>
  );
}
